<script>
    import { getContext } from "svelte";
    import {
        api_info,
        fetchWithAuthentication,
        submitDraftRequest,
    } from "../api/client.js";
    import Tags from "../components/Tags.svelte";
    import Alert from "../components/Alert.svelte";
    import { nextId } from "../components/id_generator.js";

    let loading = false;
    let subject = "";
    let detail = "";
    let organization = "";
    let tags = [];
    let alert = "";
    let timeElapsed = "";
    const context = getContext(api_info);
    function reset() {
        loading = false;
        subject = "";
        detail = "";
        organization = "";
        timeElapsed = "";
        tags = [];
    }
    async function predict() {
        loading = true;
        const startTime = performance.now();
        const response = await fetchWithAuthentication(context, "/predict/", {
            subject,
            detail,
        });
        const endTime = performance.now();
        loading = false;
        organization = response.organization;
        tags = response.tags.map((x) => ({ id: nextId(), value: x }));
        timeElapsed = Number((endTime - startTime) / 1000).toFixed(3);
    }
    // function predict() {
    //     organization = "กองสาธารณสุขฯ_รับส่งผู้ป่วย";
    //     tags = ["ป้าย1", "ป้าย2"].map((x) => ({ id: nextId(), value: x }));
    // }
    async function submit() {
        const response = await submitDraftRequest(context, {
            subject,
            detail,
            tags: tags.map((x) => x.value),
            type_name: organization,
        });
        if (response.status === true) {
            alert = "บันทึกคำร้องเรียบร้อยแล้ว";
            reset();
        } else {
            alert = "บันทึกคำร้องไม่สำเร็จ";
        }
    }
</script>

<h2>ส่งคำร้อง</h2>
<form id="user_form">
    <div class="form-group">
        <label for="subject">หัวข้อคำร้อง</label>
        <input
            type="text"
            class="form-control"
            id="subject"
            name="subject"
            placeholder="ใส่หัวข้อคำร้องที่นี่"
            bind:value={subject}
        />
    </div>
    <div class="form-group">
        <label for="detail">รายละเอียดคำร้อง</label>
        <textarea
            rows="8"
            class="form-control"
            id="detail"
            name="detail"
            placeholder="ใส่รายละเอียดคำร้องที่นี่"
            bind:value={detail}
        />
    </div>

    <button
        type="button"
        class="btn btn-primary"
        on:click={predict}
        disabled={loading}
    >
        {#if loading}
            <span class="glyphicon glyphicon-refresh spinning" />
        {/if}
        ค้นหาหน่วยงานรับผิดชอบ
    </button>
    {#if timeElapsed}
        ใช้เวลาค้นหา {timeElapsed} วินาที
    {/if}
    <span>
        {#if organization}
            <div class="form-horizontal tagging">
                <div class="form-group">
                    <label class="col-sm-2 control-label">หน่วยงาน</label>
                    <p class="col-sm-10 form-control-static">{organization}</p>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 control-label" for="tags"
                        >ป้ายกำกับ</label
                    >
                    <div class="col-sm-10">
                        <Tags
                            bind:tags
                            minTags={1}
                            allowAdd={false}
                            dragDisabled={false}
                        />
                    </div>
                </div>
                <button type="button" class="btn btn-primary" on:click={submit}
                    >ส่งคำร้อง</button
                >
                <button type="reset" class="btn" on:click={reset}
                    >เริ่มต้นใหม่</button
                >
            </div>
        {/if}
        <Alert bind:alert />
    </span>
</form>

<style>
    .tagging {
        padding-top: 20px;
        padding-bottom: 20px;
    }
</style>
